import React from "react";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function PowerDistributionCompaniesAutoComplete({
  params: params,
  options: options,
  disabled: disabled,
  label: label,
  width: width,
}) {
  // Destructure to prevent custom props from being passed to DOM
  const { value, onChange, error, errorLabel, isFieldValid, onCustomChange, ...autocompleteProps } = params;

  return (
    <Autocomplete
      disableClearable
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
      {...autocompleteProps}
      isOptionEqualToValue={(option, value) => {
        if (value === "" || !value) {
          return true;
        }
        return option.powerDistributionCompanies.name === value.powerDistributionCompanies.name;
      }}
      getOptionLabel={(option) => {
        if (option === "" || !option) {
          return "";
        }
        return option.powerDistributionCompanies.name;
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        const uniqueId = option?.powerDistributionCompanies?._id || 
                         option?.powerDistributionCompanies?.id || 
                         option?.powerDistributionCompanies?.name;
        return (
          <li key={uniqueId} {...otherProps}>
            {option?.powerDistributionCompanies?.name || ""}
          </li>
        );
      }}
      sx={{ width: width }}
      renderInput={(inputParams) => (
        <TextField 
          {...inputParams} 
          label={label}
          error={error || undefined}
          helperText={error ? errorLabel : ""}
        />
      )}
    />
  );
}
